/**
 * Default method used to compare if a row has changed and hence should
 * rerender
 */
function deepCompare(a, b, omit) {
  if (!a || !b) {
    return !a && !b;
  }
  if (a === b) {
    return true;
  }
  if (Array.isArray(a) && Array.isArray(b)) {
    return a.every((itemA, index) => deepCompare(itemA, b[index]));
  }
  for (const key of Object.getOwnPropertyNames(a)) {
    if (key === omit) {
      continue;
    }
    if (typeof a[key] === "object" && typeof b[key] === "object") {
      const areEqual = deepCompare(a[key], b[key]);
      if (!areEqual) {
        return false;
      }
    } else if (a[key] !== b[key]) {
      return false;
    }
  }
  return true;
}

export { deepCompare };
//# sourceMappingURL=deep-compare.js.map
